import { render } from "./SellerCreate.vue?vue&type=template&id=2573d83b"
import script from "./SellerCreate.vue?vue&type=script&lang=js"
export * from "./SellerCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__